import React from 'react';
import Img from 'gatsby-image';

import Section from '../components/Section';

import styles from './News.module.scss';

const News = ({
  heading,
  subheading,
  content,
  image,
  day,
  month,
  year,
  light
}) => {
  return (
    <Section light={light}>
      <div className={styles.wrapper}>
        <div className={`${styles.left} ${light ? styles.leftOrderFirst : ''}`}>
          <div className={styles.date}>
            <span className={styles.dateDay}>{day}</span>
            <span className={styles.dateMonth}>
              {month}'{year}
            </span>
          </div>
          <div className={styles.heading}>{heading}</div>
          <div className={styles.subheading}>{subheading}</div>
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
        <div className={styles.right}>
          <Img fluid={image.childImageSharp.fluid} />
        </div>
      </div>
    </Section>
  );
};

export default News;
